import { createReducer } from '@reduxjs/toolkit';
import * as actions from 'store/findProvider/actions';
import { Disclaimer } from '../types';

const DisclaimerInitState: Disclaimer = {
  isFetching: false,
  error: null
};

export const disclaimerReducer = createReducer(DisclaimerInitState, {
  [actions.PROVIDER_RESET_ACTION_TC]: state => {
    state.hasAcceptedTC = false;
    state.hasDeclinedTC = false;
    state.dateOfTC = '';
    state.tcVersion = '';
  },
  [actions.PROVIDER_SET_ACCEPTED_TC]: state => {
    state.hasAcceptedTC = true;
  }
});

export default disclaimerReducer;
